import "./ShowTag.css";

import { Breadcrumb, Button, message, Tag } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteTag, useAppSelector } from "../../../_lib/_store";

export const ShowTagPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.tag);

  const navigate = useNavigate();
  const { state } = useLocation();

  const tagObj = state?.tag;

  const handleDelete = async () => {
    const res = await deleteTag(messageApi, tagObj?.id);
    if (res) {
      navigate("/tag");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/tag">Tag</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/tag/edit`, {
                  state: { tag: state?.tag },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{tagObj?.name}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{tagObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Dislay Name</p>
            <p className="value">{tagObj?.displayName}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{tagObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Color</p>
            <p className="value">{tagObj?.color}</p>
          </div>
          <div className="row">
            <p className="label">Category</p>
            <p className="value">{tagObj?.category}</p>
          </div>
          <div className="row">
            <p className="label">Is Active</p>
            <Tag>{tagObj?.isActive ? "Yes" : "No"}</Tag>
          </div>
        </div>
      </div>
    </>
  );
};
